import { render, staticRenderFns } from "./StandardInputMultiple.vue?vue&type=template&id=8ad6c4f8&scoped=true&lang=pug&"
import script from "./StandardInputMultiple.vue?vue&type=script&lang=js&"
export * from "./StandardInputMultiple.vue?vue&type=script&lang=js&"
import style0 from "./StandardInputMultiple.vue?vue&type=style&index=0&id=8ad6c4f8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad6c4f8",
  null
  
)

export default component.exports